
import axios from 'axios';
import { takeEvery, takeLatest, put, select } from 'redux-saga/effects';
import * as actions from './actions';
import * as types from './types';
import { autoRequest } from '@api/createRequestStore';
import { getAlertDiagnosticsData } from '@api/aiAlerts';
import { message } from 'antd';

function* initRequest() {
  yield put(actions.init());
}

export function* fetchAlertDiagnosticsApi(payload) {
  yield put(actions.setFetching(true));

  try {
    const response = yield autoRequest(getAlertDiagnosticsData, types.SCOPE, payload);
    yield put(actions.setDiagnosticsData(response));
    yield put(actions.setFetching(false));
    yield put(actions.setError(false));
  } catch (error) {
    const errorMsg = error.message || 'Unknown error!';
    message.error(errorMsg);
    yield put(actions.setError(true));
    yield put(actions.setFetching(false));
  }
}

function* fetchAlertDiagnostics(action) {
  yield put(actions.setFetching(true));
  const { payload } = action;

  try {
    const response = yield autoRequest(getAlertDiagnosticsData, types.SCOPE, payload);
    yield put(actions.setDiagnosticsData(response));
    yield put(actions.setFetching(false));
    yield put(actions.setError(false));
  } catch (error) {
    const errorMsg = error.message || 'Unknown error!';
    message.error(errorMsg);
    yield put(actions.setError(true));
    yield put(actions.setFetching(false));
  }
}

function* watchInitRequest() {
  yield takeLatest([
    types.INIT,
  ], initRequest);
}

function* watchParamChanges() {
  yield takeEvery([
    types.FETCH_DATA,
  ], fetchAlertDiagnostics);
}

export default [
  watchInitRequest,
  watchParamChanges
];
